import img1 from '../img/portImages/Knight_Runner-thumbnail.jpg';
import img2 from '../img/portImages/travelnerd-thumbnail.jpg';

const portfolios = [
    {
        id: 1,
        category: 'GDScript',
        image: img1,
        link1: 'https://github.com/Rancelot/endless-runner',
        link2: 'https://www.google.com',
        title: 'Knight Runner Game',
        text: 'Games Dev Project'
    },
    {
        id: 2,
        category: 'Web Dev',
        image: img2,
        link1: 'https://github.com/jkevinruiz/travelnerd-fullstack',
        link2: 'https://www.google.com',
        title: 'Travel Nerd (MERN)',
        text: 'Group Web Dev Project'
    }
];

export default portfolios;